import { useTranslation } from 'react-i18next';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import { useSeo } from '@/hooks/useSeo';
import { useJsonLd } from '@/hooks/useJsonLd';
import { SITE_URL, SITE_NAME } from '@/lib/site';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import ValueProps from './components/ValueProps';
import TrustSection from './components/TrustSection';
import ArticlesSection from './components/ArticlesSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

const faqKeys = [
  { q: 'home.faq1Q', a: 'home.faq1A' },
  { q: 'home.faq2Q', a: 'home.faq2A' },
  { q: 'home.faq3Q', a: 'home.faq3A' },
  { q: 'home.faq4Q', a: 'home.faq4A' },
  { q: 'home.faq5Q', a: 'home.faq5A' },
  { q: 'home.faq6Q', a: 'home.faq6A' },
];

export default function Home() {
  const { t } = useTranslation();

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: SITE_NAME,
        url: `${SITE_URL}/`,
        description:
          'An independent resource hub for AllChinaBuy spreadsheet product research, trusted sellers, QC guides and shipping information.',
      },
      {
        '@type': 'WebPage',
        name: t('home.h1'),
        url: `${SITE_URL}/`,
        mainEntity: {
          '@type': 'FAQPage',
          mainEntity: faqKeys.map((faq) => ({
            '@type': 'Question',
            name: t(faq.q),
            acceptedAnswer: {
              '@type': 'Answer',
              text: t(faq.a),
            },
          })),
        },
      },
    ],
  };

  useSeo({
    title: t('home.h1'),
    description:
      'Explore the AllChinaBuy spreadsheet with curated product finds, trusted seller info, QC guides, shipping resources and buying tips for smarter product research.',
    path: '/',
    type: 'website',
  });
  useJsonLd(jsonLd);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CategorySection />
        <ValueProps />
        <TrustSection />
        <ArticlesSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}